"use client";

// import { useState } from "react";
// import Link from "next/link";
import Image from "next/image";
import { motion } from "framer-motion";
import parse from "html-react-parser";
import { IPageContent } from "@/types/pageContent.types";
// import { VideoPlayer } from "react-datocms";
// import HeroAnimatedLines from "../../home/HeroAnimatedLines";
import styles from "./styles.module.scss";

type PressKitAsset = {
  customData?: { fileName: string };
  url: string;
  alt: string;
};

export type PressKitViewProps = {
  pressKitSection1Data: IPageContent["pressKitPageModel"]["pressKitPage"]["pressKitSection1"];
  
  logoHidonix?: PressKitAsset;
  logoIon?: PressKitAsset;
  iconPictures?: PressKitAsset;

  iconPdf?: PressKitAsset;

  hidonixLogos?: PressKitAsset;
  ionLogos?: PressKitAsset;
  hidonixPictures?: PressKitAsset;
  
  ionOverviewPdf?: PressKitAsset;
  cesPressReleasePdf?: PressKitAsset;
  theCmsPdf?: PressKitAsset;
  achilleBioQuotePdf?: PressKitAsset;
  smartWearableBraceletSmartTrackingBadgePdf?: PressKitAsset;
  hidonixIndustriesBoilerplatePdf?: PressKitAsset;
  theHido2RoverPdf?: PressKitAsset;
};

const AssetLink = ({
  asset,
  suffix,
}: {
  asset?: PressKitAsset;
  suffix: 'ZIP' | 'PDF';
}) => {
  if (!asset) return null;
  return (
    <p>
      <a href={asset.url} target="_blank" rel="noopener noreferrer">
        {/* {asset.customData?.fileName} ({suffix}) */}
        {asset.alt} ({suffix})
      </a>
    </p>
  );
};

const PressKitView: React.FC<PressKitViewProps> = ({
  pressKitSection1Data,

  logoHidonix,
  logoIon,
  iconPictures,

  iconPdf,

  hidonixLogos,
  ionLogos,
  hidonixPictures,

  ionOverviewPdf,
  cesPressReleasePdf,
  theCmsPdf,
  achilleBioQuotePdf,
  smartWearableBraceletSmartTrackingBadgePdf,
  hidonixIndustriesBoilerplatePdf,
  theHido2RoverPdf
}) => {
  // console.log("PressKitView hidonixPictures:", hidonixPictures);

  const pdfAssets: PressKitAsset[] = [
    ionOverviewPdf,
    cesPressReleasePdf,
    theCmsPdf,
    achilleBioQuotePdf,
    smartWearableBraceletSmartTrackingBadgePdf,
    hidonixIndustriesBoilerplatePdf,
    theHido2RoverPdf,
  ].filter((asset): asset is PressKitAsset => !!asset);

  return (
    <>
      {/* ---------- Section 1 : Press Kit ---------- */}
      <section className={`${styles.pressKit} bkgdColorLight`}>
        <div className={`${styles.maxWidthContainer} maxWidthContainer`}>

          <div className={`${styles.copyImgContainer} innerContainer`}>
            <h1>
              {parse(pressKitSection1Data.heading)}
            </h1>


            <div className={styles.bodyContainer}>

              <div className={styles.zipCardsContainer}>
                <div className={styles.zipCard}>
                  {logoHidonix && (
                    <Image
                      className={styles.heroImage}
                      src={logoHidonix.url}
                      alt={logoHidonix.alt}
                      width="200"
                      height="200"
                      // fill
                      // style={{ objectFit: "cover" }}
                      quality={100}
                      priority
                    />
                  )}
                  <h3>{hidonixLogos?.alt}</h3>
                  <a href={hidonixLogos?.url} target="_blank" rel="noopener noreferrer">
                    Download
                  </a>
                </div>

                <div className={styles.zipCard}>
                  {logoIon && (
                    <Image
                      className={styles.heroImage}
                      src={logoIon.url}
                      alt={logoIon.alt}
                      width="200"
                      height="200"
                      // fill
                      // style={{ objectFit: "cover" }}
                      quality={100}
                      priority
                    />
                  )}
                  <h3>{ionLogos?.alt}</h3>
                  <a href={ionLogos?.url} target="_blank" rel="noopener noreferrer">
                    Download
                  </a>
                </div>

                <div className={styles.zipCard}>
                  {iconPictures && (
                    <Image
                      className={styles.heroImage}
                      src={iconPictures.url}
                      alt={iconPictures.alt}
                      width="200"
                      height="200"
                      // fill
                      // style={{ objectFit: "cover" }}
                      quality={100}
                      priority
                    />
                  )}
                  <h3>{hidonixPictures?.alt}</h3>
                  <a href={hidonixPictures?.url} target="_blank" rel="noopener noreferrer">
                    Download
                  </a>
                </div>
              </div>

              <div className={styles.pdfContainer}>
                <ul>
                  {pdfAssets.map((asset) => (
                    <li key={asset.url}>
                      <div className={styles.imgCopyContainer}>
                        {iconPdf && (
                          <Image
                            className={styles.heroImage}
                            src={iconPdf.url}
                            alt={iconPdf.alt}
                            width="50"
                            height="50"
                            // fill
                            // style={{ objectFit: "cover" }}
                            quality={100}
                            priority
                          />
                        )}
                        <AssetLink asset={asset} suffix="PDF" />
                      </div>
                      <a href={asset.url} target="_blank" rel="noopener noreferrer">
                        Download
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PressKitView;
